import Yup from '~/utils/validations/yup';

export const verifyCodeSchemaValidation = Yup.object({
  accessCode: Yup.string().required(),
});
